// Ultima cidade buscada, guardada no navegador: a busca sobrevive a um F5 e o
// "Voltar para a busca" do detalhe aberto direto sabe para onde voltar.
const KEY = 'sr-last-city'

const isCity = (city) =>
  !!city && typeof city === 'object' && city.id && typeof city.Name === 'string' && city.States && city.States.Initials

export function loadLastCity() {
  try {
    const city = JSON.parse(localStorage.getItem(KEY))
    return isCity(city) ? city : null
  } catch (err) {
    return null
  }
}

export function saveLastCity(city) {
  if (!isCity(city)) return
  try {
    // So o necessario para a busca (o objeto da API pode trazer mais campos).
    const { id, Name, States } = city
    localStorage.setItem(KEY, JSON.stringify({ id, Name, States: { Initials: States.Initials, Name: States.Name } }))
  } catch (err) {
    // Sem armazenamento (aba anonima, cota cheia) a busca so nao e lembrada.
  }
}
